"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.possibleTypes = void 0;
exports.possibleTypes = {
    "IError": [
        "AssetFinalizedError",
        "AssetNotFoundError",
        "AssetUnsupportedError",
        "AttendeeBulkCreateError",
        "DataIntegrityError",
        "InsufficientPermissionsError",
        "NoAccountError",
        "SavedInstructionColorError",
        "SiteVariableInvalidError",
        "TooManyOrganizationsError",
        "UnknownError"
    ],
    "ISiteVariable": [
        "SiteVariableColor",
        "SiteVariableDate",
        "SiteVariableImage",
        "SiteVariableLink",
        "SiteVariableNumber",
        "SiteVariableRichText",
        "SiteVariableShow",
        "SiteVariableSwitch",
        "SiteVariableText",
        "SiteVariableVideo"
    ],
    "IVideoVariableValue": [
        "SiteVariableVideoDashValue",
        "SiteVariableVideoHlsDashValue",
        "SiteVariableVideoHlsValue",
        "SiteVariableVideoProgressiveValue"
    ],
    "Resource": [
        "LinkResource",
        "ScriptResource"
    ],
    "SiteVariable": [
        "SiteVariableColor",
        "SiteVariableDate",
        "SiteVariableImage",
        "SiteVariableLink",
        "SiteVariableNumber",
        "SiteVariableRichText",
        "SiteVariableShow",
        "SiteVariableSwitch",
        "SiteVariableText",
        "SiteVariableVideo"
    ],
    "SiteVariableVideoValue": [
        "SiteVariableVideoDashValue",
        "SiteVariableVideoHlsDashValue",
        "SiteVariableVideoHlsValue",
        "SiteVariableVideoProgressiveValue"
    ],
    "TriggerResendAccessCodeResult": [
        "DataIntegrityError",
        "EmailTrigger"
    ],
    "VerifyOpenLoginResult": [
        "DataIntegrityError",
        "OpenLoginGuest"
    ],
    "VerifyPublicPasscodeResult": [
        "DataIntegrityError",
        "PublicPasscodeOutput"
    ]
};
